export default "__VITE_ASSET__LUSaPhnj__"